import React, {useEffect, useState} from 'react';
import {Dimensions, View, StyleSheet, ActivityIndicator} from 'react-native';
import {Button, Input} from 'react-native-elements';
import HomeHeader from '../../components/HomeHeader';
import {storeProfileInfo} from '../../database/DataBase';
import {getProfileInfo, updateProfileInfo} from '../../network/Network';
import {FaComment} from 'react-icons/fa';
import Loading from '../../components/Loading';

const HEIGHT = Dimensions.get('window').height;
const WIDTH = Dimensions.get('window').width;

export default function ProfileEditScreen(props) {
  
  const [fname, setFName] = useState('');
  const [lname, setLName] = useState('');
  const [mname, setMName] = useState('');
  const [email, setEmail] = useState('');
  const [dob, setDob] = useState('');
  const [pincode, setPincode] = useState('');
  const [address, setAddress] = useState('');
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    getProfileInfo(true)
      .then((data) => {
        if (
          data.success === true &&
          (data.status === 201 || data.status === 200)
        ) {
          setFName(data.data.profile.fname);
          setMName(data.data.profile.mname);
          setLName(data.data.profile.lname);
          setEmail(data.data.profile.email);
          setDob(data.data.profile.dob);
          setPincode(data.data.profile.pincode);
          setAddress(data.data.profile.billing_address.addr);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }, []);

  const onSaveClick = () => {
    setLoading(true);
    updateProfileInfo(fname, mname, lname, email, dob, pincode, address)
      .then((data) => {
        if (
          data.success === true &&
          (data.status === 201 || data.status === 200)
        ) {
          storeProfileInfo(data).then(() => {
            setLoading(false);

            props.navigation.goBack();
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <View style={styles.viewStyle}>
      <HomeHeader navigation={props.navigation} />
      {isLoading ? (
        <View style={styles.indicatorViewStyle}>
          <Loading />
        </View>
      ) : (
        <View style={styles.container}>
          <View style={styles.content}>
            <Input
              placeholder="First Name"
              leftIcon={<FaComment color="white" />}
              style={styles.inputStyle}
              value={fname}
              onChangeText={(value) => setFName(value)}
            />
            <Input
              placeholder="Middle Name"
              leftIcon={<FaComment color="white" />}
              style={styles.inputStyle}
              value={mname}
              onChangeText={(value) => setMName(value)}
            />
            <Input
              placeholder="Last Name"
              leftIcon={<FaComment color="white" />}
              style={styles.inputStyle}
              value={lname}
              onChangeText={(value) => setLName(value)}
            />
            <Input
              placeholder="Email"
              leftIcon={<FaComment color="white" />}
              style={styles.inputStyle}
              value={email}
              onChangeText={(value) => setEmail(value)}
              keyboardType="email-address"
            />
            <Input
              placeholder="Date of birth"
              leftIcon={<FaComment color="white" />}
              style={styles.inputStyle}
              value={dob}
              onChangeText={(value) => setDob(value)}
            />
            <Input
              multiline={true}
              placeholder="Address"
              leftIcon={<FaComment color="white" />}
              style={styles.inputStyle}
              value={address}
              onChangeText={(value) => setAddress(value)}
            />
            <Input
              placeholder="Pincode"
              leftIcon={<FaComment color="white" />}
              style={styles.inputStyle}
              value={pincode}
              onChangeText={(value) => setPincode(value)}
              keyboardType="number-pad"
            />
            <Button
              title="Save"
              buttonStyle={styles.buttonStyle}
              onPress={onSaveClick}
              loading={loading}
            />
          </View>
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  viewStyle: {
    height: HEIGHT,
  },
  indicatorViewStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1
  },
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    width: WIDTH < 720 ? WIDTH * 0.9 : WIDTH / 2
  },
  inputStyle: {
    color: 'white',
    fontFamily: 'Source Sans Pro, sans-serif',
    fontWeight: 'normal',
  },
  buttonStyle: {
    backgroundColor: '#e10808',
    margin: 16
  },
});
